module.exports = __webpack_public_path__ + "static/banner-190465fc9b68f1eded5ca90f65d79a6e.png";